import React from 'react';
import AllRefundContainer from '../../../Containers/AdminContainer/AllRefund';

const AllRefundScreen = () => {
  return <AllRefundContainer />;
};

export default AllRefundScreen;
